(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6291],{

/***/ 77293:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/[...details]",
      function () {
        return __webpack_require__(2722);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ RadiusShadowContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77303);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var RadiusShadowContainer = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: children
    });
};


/***/ }),

/***/ 2722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _details_; },
  "generateDescription": function() { return /* binding */ generateDescription; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./modules/Context/useAuth0User.tsx
var useAuth0User = __webpack_require__(65200);
// EXTERNAL MODULE: ./modules/JobFavouriteButton/index.tsx + 2 modules
var JobFavouriteButton = __webpack_require__(76242);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
;// CONCATENATED MODULE: ./modules/JobPointOfContact/assets/specialist-jessica-pearson.png
/* harmony default export */ var specialist_jessica_pearson = ({"src":"https://cdn.medrecruit.medworld.com/0861f9faa132466797439461b87a432016bab643/_next/static/media/specialist-jessica-pearson.92044142.png","height":182,"width":278,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAATlBMVEXD2/ybv/aIkqEaICnL4fy2vc/Ptamjv+bM0+602P/MubUQGSK/loWf3P8bHSKGipBlV1BTREKd//+WnKTW8P+hjIE7NDR+YVTVsaGefW/WhuNrAAAAFnRSTlMBQWT8NF+WG0pIuPv1L9xd4v0QiVPLZUmmPgAAAAlwSFlzAAALEwAACxMBAJqcGAAAADJJREFUCJkVyMURgDAAAMGLEIW40X+jDPtcwGkzLWD9dd4MiEfeu7c/Ul3FoUdYKm7zAR98AaH8RKsEAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./modules/JobPointOfContact/components/JobContactGeneric/JobContactGeneric.module.scss
var JobContactGeneric_module = __webpack_require__(52555);
var JobContactGeneric_module_default = /*#__PURE__*/__webpack_require__.n(JobContactGeneric_module);
;// CONCATENATED MODULE: ./modules/JobPointOfContact/components/JobContactGeneric/JobContactGeneric.tsx




var JobContactGeneric = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (JobContactGeneric_module_default()).jobContactGeneric,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (JobContactGeneric_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (JobContactGeneric_module_default()).image,
                    src: specialist_jessica_pearson,
                    priority: true,
                    alt: "",
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (JobContactGeneric_module_default()).contentContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (JobContactGeneric_module_default()).textContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (JobContactGeneric_module_default()).title,
                            children: "Want to speak to someone about this role?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (JobContactGeneric_module_default()).description,
                            children: "Enquire to get connected to an expert recruiter."
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/JobPointOfContact/components/JobContactSpecialist/JobContactSpecialist.module.scss
var JobContactSpecialist_module = __webpack_require__(91390);
var JobContactSpecialist_module_default = /*#__PURE__*/__webpack_require__.n(JobContactSpecialist_module);
;// CONCATENATED MODULE: ./modules/JobPointOfContact/components/JobContactSpecialist/JobContactSpecialist.tsx



var JobContactSpecialist = function(param) {
    var jobNumber = param.jobNumber, name = param.name, role = param.role, phone = param.phone, email = param.email, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (JobContactSpecialist_module_default()).jobContactSpecialist,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (JobContactSpecialist_module_default()).title,
                children: "Get in touch with:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (JobContactSpecialist_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (JobContactSpecialist_module_default()).image,
                    src: image,
                    priority: true,
                    alt: "Portrait of ".concat(name, ", ").concat(role)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (JobContactSpecialist_module_default()).contentContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (JobContactSpecialist_module_default()).textContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (JobContactSpecialist_module_default()).name,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (JobContactSpecialist_module_default()).role,
                                children: role
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (JobContactSpecialist_module_default()).contactDetails,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "tel:".concat(phone),
                                            children: phone
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (JobContactSpecialist_module_default()).email,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:".concat(email),
                                            children: email
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (JobContactSpecialist_module_default()).jobReference,
                        children: [
                            "Please quote job reference: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: jobNumber
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./modules/JobPointOfContact/assets/specialist-cara-gane.png
/* harmony default export */ var specialist_cara_gane = ({"src":"https://cdn.medrecruit.medworld.com/0861f9faa132466797439461b87a432016bab643/_next/static/media/specialist-cara-gane.13916e96.png","height":182,"width":278,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAATlBMVEXF4fg9O0PU8f+7iHXN7P+sxOsyMTpMaXE0MzqhwO3O2+9HVGxjfaKdv/RtW1tzcXuli4MaEA/Z5f11VUScbl6Ql6gzLDBEMCkvIyGodGCDcikBAAAAF3RSTlMX/i78QVC5AP49B3k8BfGLlvFhkfqJ5qS9BxAAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAySURBVAiZBcGHAYAgEACxoz5IU4rK/ouSIJeN40YQbDMmCyVqv2cCnH++/3XoXoMKah0fmgGBruSmowAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/JobPointOfContact/assets/specialist-dominique-ross.png
/* harmony default export */ var specialist_dominique_ross = ({"src":"https://cdn.medrecruit.medworld.com/0861f9faa132466797439461b87a432016bab643/_next/static/media/specialist-dominique-ross.12e7005c.png","height":182,"width":278,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAASFBMVEUjJCl4WlKwiX6Dl7e0yuvL7PqCmbi40/RMaXHS7/87PkcZGiBFTl8uMz6UufF6cXJ8hpYNCgk9UGtLZonj9/9pU00GBgkPDQwmY9RPAAAAFnRSTlP9/P5RBjBFFwBE1umSpEGsaOB3QVnA4iwxXAAAAAlwSFlzAAALEwAACxMBAJqcGAAAADBJREFUCJkFwYcBwCAMwDAzk0AX+/9PK6HR8npFUbHL+6HEJ93OdUEst7NrIM0PoPwgVAFmYjfMbwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/JobPointOfContact/assets/specialist-elliemae-middleton.png
/* harmony default export */ var specialist_elliemae_middleton = ({"src":"https://cdn.medrecruit.medworld.com/0861f9faa132466797439461b87a432016bab643/_next/static/media/specialist-elliemae-middleton.d87c68ef.png","height":182,"width":278,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAVFBMVEVMaXF+X1OQr+OjnqfF6/mftNx3bXDI6fy2xuXQ9f/j//9/XUy52v96o9dIREvi5/8+KSJGNzWKcmurhXdaf7CUiInqyrzGln5bRT2MXkiabFlHLyZSDW4pAAAAF3RSTlMA6xtdMEebFwY9U9xMMqpL3/zK/VKPoKCRjSUAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA0SURBVAiZBcGJAoAQEEDBJ8cuJUrR8f//aQY02jUIsMQwTAb1bv/MJcjm6/ufBZfupx2jTx1uAcEAC4oUAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/JobPointOfContact/assets/specialist-jack-longden.png
/* harmony default export */ var specialist_jack_longden = ({"src":"https://cdn.medrecruit.medworld.com/0861f9faa132466797439461b87a432016bab643/_next/static/media/specialist-jack-longden.0554153a.png","height":354,"width":455,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAASFBMVEW83fgsLDBGT2E7R1mu0frK5P+py/wZHCFMaXGu0/KBmcEuMTn+//+UjIivjHyWfnhoe5h8Z1hxYVbBusCljIElJy1yW1TFpZNcDsXXAAAAFXRSTlMh9mu2M0pH/gAFOdg2Kfm9RsaBfuON/rWyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAANUlEQVQImQXBhwGAMAzAMLdkssoK/P8pEpFs5xVBoPf3EKSY7oMEk/62acb0aFW1IGt3L/cfLqcBvN/9xNwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./modules/JobPointOfContact/assets/specialist-katie-lovell.png
/* harmony default export */ var specialist_katie_lovell = ({"src":"https://cdn.medrecruit.medworld.com/0861f9faa132466797439461b87a432016bab643/_next/static/media/specialist-katie-lovell.c7c748e7.png","height":382,"width":474,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAASFBMVEVMaXGtzPyxz/ySe2+QnKrO5P2Ji4ibw/XC3/+/2P1qV0mmf2toVUCSiYGfgW+Ob1ptWkhyWUCNkpOHfW+EgHe7j3quiXV5bV2rWy3rAAAAFHRSTlMALjyuU0P8ORVOh8sT/Yz4RDuB4igiMBkAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA3SURBVAiZFcRBFoAgCEDBX6FAZWph3f+mvmYxAJzt39yutwOL6zF2MFWpY4PV9flyEVKSiBz3BCQ4AZyCKBWoAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./modules/JobPointOfContact/assets/specialist-louise-anker.png
/* harmony default export */ var specialist_louise_anker = ({"src":"https://cdn.medrecruit.medworld.com/0861f9faa132466797439461b87a432016bab643/_next/static/media/specialist-louise-anker.63018b36.png","height":182,"width":278,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAQlBMVEXD1vvg8f86PEeYv/uq3v3L4P3SrKC3zfOPwP2q1P/Ap6EuKzPZrKPerp2mgYDN3/tdXm23kIaYcWxDRlHJl4tPQUOdAwV/AAAAFHRSTlMCMvwYKj6pTTsZpfzR9b9jcd/EuOHmKiYAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAwSURBVAiZBcEHAoAgDACxK5QOlaHo/79qArRmRwLVvd8KROh4IknXdX6XI1N2Ka/9FzMBNa+b/VcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/JobPointOfContact/assets/specialist-sophie-szczudlo.png
/* harmony default export */ var specialist_sophie_szczudlo = ({"src":"https://cdn.medrecruit.medworld.com/0861f9faa132466797439461b87a432016bab643/_next/static/media/specialist-sophie-szczudlo.f105d4a2.png","height":372,"width":462,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAATlBMVEVMaXGpn5iAalp8a2Cx0f6kxvmnoKTI4v/F2PeTsNvc5vaEcWMfSWa+ublrf5ZZVE9FQTyWqcOqnInPsZ94WkkrLDG9mINrXE9HRkWZiHFZWB71AAAAE3RSTlMAcfDkRD5XRiY0CEMLQyzj+2TeJ7NbMgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADRJREFUCJkFwYcBgDAMwDB3JgG6mf8/igRsuB1ApaxwAEny7StoMvf4ATHafL9giGi7+pl/IToBkoM+JyEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./modules/JobPointOfContact/assets/specialist-thropa.png
/* harmony default export */ var specialist_thropa = ({"src":"https://cdn.medrecruit.medworld.com/0861f9faa132466797439461b87a432016bab643/_next/static/media/specialist-thropa.94ab1725.png","height":354,"width":455,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAWlBMVEVMaXFAOT96XEiawv297v+/1vonISO0z/q75f/S6PqdxP7O4f5lSTOFXEhwbHddRT7Vrp2knrC+lHqdeW9jSkBUXnS0g29JQkZYYHingGnLmH+UZ0y+hWs4MDOre1MhAAAAGnRSTlMA9v4xLVf8SAchITZdp5b8XlY0n8NuprVO3NqzdBUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA4SURBVAiZBcEHAoAgDACxAwtt3Rtc//+mCZjTXyvgSYZ7BmtU9neBVuWIU6ho8hLDN9KpnU/O2w8xRgIBXEJXDQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./modules/JobPointOfContact/specialistInfo.ts









var specialistInfo = {
    jessicaPearson: {
        name: "Jessica Pearson",
        role: "Executive Solutions Specialist",
        phone: "+64 3 450 9313",
        email: "jessica.pearson@medrecruit.com",
        image: specialist_jessica_pearson
    },
    louiseAnker: {
        name: "Louise Anker",
        role: "Senior Division Manager",
        phone: "+61 7 5553 9606",
        email: "louise.anker@medrecruit.com",
        image: specialist_louise_anker
    },
    dominiqueRoss: {
        name: "Dominique Ross",
        role: "Senior Solutions Specialist",
        phone: "+64 3 450 9314",
        email: "dominique.ross@medrecruit.com",
        image: specialist_dominique_ross
    },
    caraGane: {
        name: "Cara Gane",
        role: "Team Leader - GP Clinic Division",
        phone: "+61 75 520 9566",
        email: "cara.gane@medrecruit.com",
        image: specialist_cara_gane
    },
    elliemaeMiddleton: {
        name: "Ellie-Mae Middleton",
        role: "Solution Specialist - Permanent",
        phone: "+61 75 610 5019",
        email: "elliemae.middleton@medrecruit.com",
        image: specialist_elliemae_middleton
    },
    sophieSzczudlo: {
        name: "Sophie Szczudlo",
        role: "Solutions Specialist - Junior & Registrar Division",
        phone: "+61 7 5610 5059",
        email: "sophie.szczudlo@medrecruit.com",
        image: specialist_sophie_szczudlo
    },
    thropaHearne: {
        name: "Thropa Hearne",
        role: "Solutions Specialist - Anaesthetics Registrar",
        phone: "+61 3 8657 5579",
        email: "thropa.hearne@medrecruit.com",
        image: specialist_thropa
    },
    jackLongden: {
        name: "Jack Longden",
        role: "Solutions Specialist - Paediatrics Registrar",
        phone: "+61 7 5553 9613",
        email: "jack.longden@medrecruit.com",
        image: specialist_jack_longden
    },
    katieLovell: {
        name: "Katie Lovell",
        role: "Solutions Specialist - Psychiatry Registrar",
        phone: "+61 7 5610 5057",
        email: "katie.lovell@medrecruit.com",
        image: specialist_katie_lovell
    }
};

;// CONCATENATED MODULE: ./modules/JobPointOfContact/components/getContactForJob.ts



var stringContains = function(str, substr) {
    return str.toLowerCase().includes(substr.toLowerCase());
};
var getIsGeneralPractice = function(specialty) {
    return stringContains(specialty, "General practice") || stringContains(specialty, "GP -");
};
var getContactForJob = function(param) {
    var specialty = param.specialty, countryCode = param.countryCode, placementType = param.placementType;
    if (!specialty) {
        return null;
    }
    if (stringContains(specialty, "Radiology")) {
        return specialistInfo.jessicaPearson;
    }
    if (stringContains(specialty, "Family medicine")) {
        return specialistInfo.caraGane;
    }
    var isAustralia = countryCode === "AU";
    var isPermanentJob = placementType === "Permanent";
    var isGeneralPractice = getIsGeneralPractice(specialty);
    if (isAustralia && stringContains(specialty, "General medicine")) {
        return specialistInfo.louiseAnker;
    }
    if (isAustralia && isPermanentJob && !isGeneralPractice) {
        return specialistInfo.elliemaeMiddleton;
    }
    var isNewZealand = countryCode === "NZ";
    if (isNewZealand && stringContains(specialty, "Psychiatry")) {
        return specialistInfo.dominiqueRoss;
    }
    return null;
};
var getRegistrarSpecialistContact = function(param) {
    var specialty = param.specialty, countryCode = param.countryCode, placementType = param.placementType;
    if (!specialty || countryCode !== "AU" || placementType === "Permanent") {
        return null;
    }
    if (stringContains(specialty, "Surgery")) {
        return specialistInfo.sophieSzczudlo;
    }
    if (stringContains(specialty, "Intensive Care Medicine")) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, specialistInfo.thropaHearne), {
            role: "Solutions Specialist - ICU Registrar"
        });
    }
    if (stringContains(specialty, "Anaesthetics")) {
        return specialistInfo.thropaHearne;
    }
    if (stringContains(specialty, "Psychiatry")) {
        return specialistInfo.katieLovell;
    }
    if (stringContains(specialty, "Paediatrics")) {
        return specialistInfo.jackLongden;
    }
    if (stringContains(specialty, "Obstetrics and Gynaecology")) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, specialistInfo.jackLongden), {
            role: "Solutions Specialist - O&G Registrar"
        });
    }
    return null;
};

;// CONCATENATED MODULE: ./modules/JobPointOfContact/JobPointOfContact.tsx





var JobPointOfContact = function(param) {
    var jobNumber = param.jobNumber, isLoggedIn = param.isLoggedIn, specialty = param.specialty, grade = param.grade, placementType = param.placementType, countryCode = param.countryCode;
    var getSpecialistContactDetailsProp = {
        specialty: specialty,
        placementType: placementType,
        countryCode: countryCode
    };
    var specialistContactDetails = grade === "Registrar" ? getRegistrarSpecialistContact(getSpecialistContactDetailsProp) : getContactForJob(getSpecialistContactDetailsProp);
    var shouldUseSpecialist = isLoggedIn && specialistContactDetails;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shouldUseSpecialist ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobContactSpecialist, (0,_object_spread/* default */.Z)({
            jobNumber: jobNumber
        }, specialistContactDetails)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(JobContactGeneric, {})
    });
};

// EXTERNAL MODULE: ./utils/urlHelper.ts
var urlHelper = __webpack_require__(52484);
// EXTERNAL MODULE: ./components/JobApplicationStatusLabel/index.tsx
var JobApplicationStatusLabel = __webpack_require__(12042);
// EXTERNAL MODULE: ./components/JobInformation/index.tsx + 4 modules
var JobInformation = __webpack_require__(73037);
// EXTERNAL MODULE: ./components/RadiusShadowContainer/index.tsx
var RadiusShadowContainer = __webpack_require__(41342);
// EXTERNAL MODULE: ./components/ShareContainer/index.tsx + 1 modules
var ShareContainer = __webpack_require__(35079);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./modules/JobButton/index.tsx
var JobButton = __webpack_require__(91632);
// EXTERNAL MODULE: ./modules/JobListingJobCardList/index.tsx + 5 modules
var JobListingJobCardList = __webpack_require__(51241);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/jobListingHelper.ts
var jobListingHelper = __webpack_require__(92628);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ApartmentOutlined.js
var ApartmentOutlined = __webpack_require__(23164);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/RoomOutlined.js
var RoomOutlined = __webpack_require__(24155);
// EXTERNAL MODULE: ./modules/SimilarJobs/SimilarJobs.module.scss
var SimilarJobs_module = __webpack_require__(46979);
var SimilarJobs_module_default = /*#__PURE__*/__webpack_require__.n(SimilarJobs_module);
;// CONCATENATED MODULE: ./modules/SimilarJobs/SimilarJobs.tsx









var SimilarJobs = function(param) {
    var jobs = param.jobs, referringJobNumber = param.referringJobNumber;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SimilarJobs_module_default()).container,
        children: !!jobs.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "subtitle1",
                    component: "h4",
                    className: (SimilarJobs_module_default()).title,
                    children: "Similar Jobs"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    dense: false,
                    children: jobs.map(function(job) {
                        var subspcialityOrSpeciality = job.subspeciality ? job.subspeciality : job.speciality;
                        var jobUrl = (0,jobListingHelper/* generateJobDetailsURL */.wZ)(job.jobNumber, job.grade, subspcialityOrSpeciality);
                        var locationInfo = (0,jobListingHelper/* generateLocationInfo */.WC)(job.locationDisplay, job.country, job.city);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                primary: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    prefetch: false,
                                    href: {
                                        pathname: jobUrl
                                    },
                                    as: jobUrl,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        onClick: function() {
                                            return track("Job Details", {
                                                jobNumber: job.jobNumber,
                                                "Details Origin": "Similar Jobs",
                                                "Details Action": "Title Link",
                                                referringJobNumber: referringJobNumber
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            component: "h5",
                                            "data-testid": "title",
                                            children: job.title
                                        })
                                    })
                                }),
                                secondary: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "body1",
                                            component: "p",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomOutlined/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    "data-testid": "similar-job-location",
                                                    children: locationInfo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "body1",
                                            component: "p",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ApartmentOutlined/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    "data-testid": "work-type",
                                                    children: job.workType
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, job.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var SimilarJobs_SimilarJobs = (SimilarJobs);

;// CONCATENATED MODULE: ./modules/SimilarJobs/index.tsx


// EXTERNAL MODULE: ./modules/UserLoggedinContainer/index.tsx
var UserLoggedinContainer = __webpack_require__(74304);
// EXTERNAL MODULE: ./utils/limitTextLength.ts
var limitTextLength = __webpack_require__(69764);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./pages/jobs/style.module.scss
var style_module = __webpack_require__(84306);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./pages/jobs/[...details].tsx























var __N_SSP = true;
var generateDescription = function(grade, speciality, locationSummary, jobNumber) {
    var clientDescriptionPlainText = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    //Removing tags //n
    var sanitizedDescription = clientDescriptionPlainText && clientDescriptionPlainText.replace(/\n/g, "");
    var description = "Medrecruit is seeking a ".concat(speciality, " - ").concat(grade, " in ").concat(locationSummary, ". ref# ").concat(jobNumber, ". ");
    return (0,limitTextLength/* textlengthLimit */.r)(description.concat(sanitizedDescription), 160);
};
var generateTitle = function(jobNumber, speciality) {
    var jobNumberSuffix = " - ".concat(jobNumber);
    var spaceForSpecialty = 60 - jobNumberSuffix.length;
    return "".concat(speciality.substring(0, spaceForSpecialty)).concat(jobNumberSuffix);
};
/**
 * The page will be used to render the job details page, jobNumber or UUID of job used to render the page
 * /jobs/grade/speciality/jnxxxxxxxx
 * /jobs/grade/jnxxxxxxxx
 * /jobs/jnxxxxxxxx
 */ var Job = function(param) {
    var detail = param.detail, isExpired = param.isExpired, similarJobs = param.similarJobs;
    var ref;
    var router = (0,next_router.useRouter)();
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var user = (0,useAuth0User/* useAuth0User */.a)().user;
    (0,react.useEffect)(function() {
        if (detail) {
            track("Job Details page loaded", {
                jobNumber: detail.jobNumber,
                open: !isExpired
            });
        }
    }, [
        router.query
    ]);
    if (!detail) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserLoggedinContainer/* UserLoggedinContainer */.C, {
            style: UserLoggedinContainer/* ContainerStyle.DARK_BLUE_BANNER */.N.DARK_BLUE_BANNER,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (style_module_default()).unavailableHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Sorry, unable to find this job listing."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: (style_module_default()).searchBtn,
                        variant: "contained",
                        size: "medium",
                        color: "secondary",
                        onClick: function() {
                            router.push(path/* PATH.JOBS */.m.JOBS);
                        },
                        children: "Return to job search"
                    })
                ]
            })
        });
    }
    var id = detail.id, description = detail.description, clientDescription = detail.clientDescription, clientDescriptionPlainText = detail.clientDescriptionPlainText, jobNumber = detail.jobNumber, title = detail.title, grade = detail.grade, speciality = detail.speciality, subspeciality = detail.subspeciality, isSaved = detail.isSaved, appliedStatus = detail.appliedStatus, accountName = detail.accountName, displayClientName = detail.displayClientName, clientNameMessage = detail.clientNameMessage, workType = detail.workType, country = detail.country;
    var locationSummary = (0,jobListingHelper/* generateLocationInfo */.WC)(detail.locationDisplay, detail.country, detail.city);
    var hasSimilarJobs = similarJobs && similarJobs.length > 0;
    var newLineEncoding = "%0d%0a";
    var seoSpecialtyText = speciality || "";
    var specialtyOrSubspecialityText = subspeciality ? subspeciality : seoSpecialtyText;
    var seoDescription = generateDescription(grade, specialtyOrSubspecialityText, locationSummary, jobNumber, clientDescriptionPlainText);
    var seoTitle = generateTitle(jobNumber, specialtyOrSubspecialityText);
    var canonicalUrl = (0,jobListingHelper/* generateJobDetailsURL */.wZ)(jobNumber, grade, specialtyOrSubspecialityText);
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isExpired && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserLoggedinContainer/* UserLoggedinContainer */.C, {
                    style: UserLoggedinContainer/* ContainerStyle.DARK_BLUE_BANNER */.N.DARK_BLUE_BANNER,
                    noFooterMargin: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                            noindex: true,
                            nofollow: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (style_module_default()).unavailableHeader,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Sorry, this job listing is no longer available."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Job reference: ",
                                        jobNumber
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: (style_module_default()).searchBtn,
                                    variant: "contained",
                                    size: "medium",
                                    color: "secondary",
                                    onClick: function() {
                                        router.push(path/* PATH.JOBS */.m.JOBS);
                                    },
                                    children: "Return to job search"
                                })
                            ]
                        }),
                        hasSimilarJobs && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (style_module_default()).similarJobTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Here are some other jobs that may be similar."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (style_module_default()).similarJobs,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobListingJobCardList/* default */.Z, {
                                        jobs: similarJobs,
                                        suppressCTABanner: true
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            !isExpired && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserLoggedinContainer/* UserLoggedinContainer */.C, {
                style: UserLoggedinContainer/* ContainerStyle.DARK_BLUE_BANNER */.N.DARK_BLUE_BANNER,
                noFooterMargin: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (style_module_default()).paddingBox,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                            title: seoTitle,
                            description: seoDescription,
                            noindex: true,
                            nofollow: true,
                            openGraph: {
                                title: seoTitle,
                                description: seoDescription,
                                type: "website"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RadiusShadowContainer/* RadiusShadowContainer */.o, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (style_module_default()).article,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            container: true,
                                            spacing: 3,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    item: true,
                                                    md: 7,
                                                    xs: 12,
                                                    className: (style_module_default()).jobDetailsContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (style_module_default()).pill,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                className: (style_module_default()).speciality,
                                                                children: grade
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            className: (style_module_default()).detailTitle,
                                                            children: subspeciality ? subspeciality : speciality
                                                        }),
                                                        user && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (style_module_default()).locationAndClient,
                                                            children: displayClientName ? accountName : clientNameMessage || "Client Name Withheld"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (style_module_default()).locationAndClient,
                                                            "data-testid": "job-location-details",
                                                            children: locationSummary
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (style_module_default()).actions,
                                                            children: [
                                                                appliedStatus ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (style_module_default()).status,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobApplicationStatusLabel/* JobApplicationStatusLabel */.h, {
                                                                        status: appliedStatus
                                                                    })
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(JobButton/* JobButton */.E, {
                                                                            id: id,
                                                                            jobNumber: jobNumber,
                                                                            url: canonicalUrl,
                                                                            className: (style_module_default()).enquireButton
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(JobFavouriteButton/* default */.Z, {
                                                                            id: id,
                                                                            jobNumber: jobNumber,
                                                                            favourited: isSaved,
                                                                            style: "outlined",
                                                                            className: (style_module_default()).bannerButton
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareContainer/* default */.Z, {
                                                                    text: "",
                                                                    jobOrArticleShare: "jobshare",
                                                                    id: id,
                                                                    className: (style_module_default()).shareBox,
                                                                    buttonClassName: classnames_default()((style_module_default()).bannerButton, (style_module_default()).iconButton),
                                                                    emailTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            "Who would you like ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                            " to send this job to?"
                                                                        ]
                                                                    }),
                                                                    emailSubject: "".concat((ref1 = user === null || user === void 0 ? void 0 : user.given_name) !== null && ref1 !== void 0 ? ref1 : "Medrecruit", " recommended a job for you"),
                                                                    emailBody: "View the job recommended for you by ".concat((ref2 = user === null || user === void 0 ? void 0 : user.given_name) !== null && ref2 !== void 0 ? ref2 : "Medrecruit", " ").concat(newLineEncoding).concat(encodeURI((0,urlHelper/* getUtmShareUrl */.En)("jobshare", "".concat((ref = globalThis.location) === null || ref === void 0 ? void 0 : ref.origin).concat(canonicalUrl), "email"))),
                                                                    facebookTitle: title,
                                                                    shareTrackingProps: {
                                                                        name: "Share Job",
                                                                        details: {
                                                                            "Share Origin": "Job Detail",
                                                                            jobNumber: jobNumber
                                                                        }
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    md: 5,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPointOfContact, {
                                                        jobNumber: jobNumber,
                                                        placementType: workType,
                                                        isLoggedIn: !!user,
                                                        specialty: subspeciality ? subspeciality : speciality,
                                                        grade: grade,
                                                        countryCode: country
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: (style_module_default()).hr
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            container: true,
                                            spacing: 3,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    item: true,
                                                    md: 8,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            component: "h3",
                                                            className: (style_module_default()).detailSubTitle,
                                                            children: "Job Description:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (style_module_default()).content,
                                                            dangerouslySetInnerHTML: {
                                                                __html: description || "Not Available"
                                                            }
                                                        }),
                                                        clientDescription && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: "subtitle1",
                                                                    component: "h3",
                                                                    className: (style_module_default()).detailSubTitle,
                                                                    children: "Client Description:"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (style_module_default()).content,
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: "<p>".concat(clientDescription, "</p>")
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    item: true,
                                                    md: 4,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (style_module_default()).informationBox,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobInformation/* JobInformation */.ym, {
                                                                job: detail
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SimilarJobs_SimilarJobs, {
                                                            referringJobNumber: jobNumber,
                                                            jobs: similarJobs || []
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    item: true,
                                                    md: 8,
                                                    xs: 12,
                                                    children: [
                                                        !appliedStatus && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                            item: true,
                                                            md: 5,
                                                            xs: 12,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (style_module_default()).detailContentApply,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobButton/* JobButton */.E, {
                                                                    id: id,
                                                                    jobNumber: jobNumber,
                                                                    url: canonicalUrl
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: (style_module_default()).reference,
                                                            children: [
                                                                "Job reference: ",
                                                                jobNumber
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var _details_ = (Job);


/***/ }),

/***/ 77303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__A_XKr"};

/***/ }),

/***/ 52555:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobContactGeneric":"JobContactGeneric_jobContactGeneric__x44Zx","imageContainer":"JobContactGeneric_imageContainer__gBZvC","image":"JobContactGeneric_image__elv2W","contentContainer":"JobContactGeneric_contentContainer__SPNyE","textContainer":"JobContactGeneric_textContainer__xHvVf","title":"JobContactGeneric_title__fjPH3","description":"JobContactGeneric_description__6X8Po"};

/***/ }),

/***/ 91390:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobContactSpecialist":"JobContactSpecialist_jobContactSpecialist__bsLQD","title":"JobContactSpecialist_title__Vayjd","imageContainer":"JobContactSpecialist_imageContainer__Z_amT","image":"JobContactSpecialist_image__BDT4Q","contentContainer":"JobContactSpecialist_contentContainer__moVe6","textContainer":"JobContactSpecialist_textContainer__rTbyU","name":"JobContactSpecialist_name__yl9O_","role":"JobContactSpecialist_role___HGCl","contactDetails":"JobContactSpecialist_contactDetails__TNFJy","email":"JobContactSpecialist_email__QO4mG","jobReference":"JobContactSpecialist_jobReference__dH6ZO"};

/***/ }),

/***/ 46979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SimilarJobs_container__Drmfp","title":"SimilarJobs_title__FjXj4"};

/***/ }),

/***/ 84306:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageHeadingCentered":"style_pageHeadingCentered__JWTNl","paddingBox":"style_paddingBox__VPFwP","pill":"style_pill___IWa_","detailTitle":"style_detailTitle__VO4bV","locationAndClient":"style_locationAndClient__grmXs","content":"style_content__YcKSS","noLoingNotice":"style_noLoingNotice__SfNCj","informationBox":"style_informationBox__tGsFl","hr":"style_hr__qLQSm","actions":"style_actions__UPrtJ","detailSubTitle":"style_detailSubTitle__HKqRv","detailContentApply":"style_detailContentApply__Mkju4","reference":"style_reference__S43WL","article":"style_article__4v2W1","landingContainer":"style_landingContainer__lg_xE","title":"style_title___Ri5x","more":"style_more__RW_RU","emptyJob":"style_emptyJob__zOwAM","link":"style_link__XPI_n","unavailableHeader":"style_unavailableHeader__0iKXc","searchBtn":"style_searchBtn___YQef","similarJobTitle":"style_similarJobTitle__zBdr_","shareBox":"style_shareBox__IaYkO","status":"style_status___9y_n","posRel":"style_posRel__BLElf","jobListContainer":"style_jobListContainer__E01Bx","similarJobs":"style_similarJobs__D_D6R","jobDetailsContainer":"style_jobDetailsContainer__EXizB","enquireButton":"style_enquireButton__BAqF2","bannerButton":"style_bannerButton__bdmTq","iconButton":"style_iconButton__qvS4b"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2491,5675,9669,4872,9043,773,7243,2628,933,7422,1241,9774,2888,179], function() { return __webpack_exec__(77293); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);